import { useNavigate, useParams } from "react-router-dom";
import { JournalData, JournalForm } from "./components/commonJournalForm";
import { createJournalApi, updateJournalApi } from "src/network/api";
import { toast } from "react-toastify";
import PageLayout from "./PageLayout";
import { Button, Card, CardBody, CardHeader } from "reactstrap";

const CreateJournalPage = () => {
  const navigate = useNavigate();

  const { journalId } = useParams();

  const onSubmit = async (data: JournalData) => {
    try {
      let response = await createJournalApi(data);
      if (response.status === 200 && response.data.status === 200) {
        toast.success(response.data.message || "Journal created successfully!");
        navigate("/");
      } else {
        toast.error(response.data.message || "Failed to create journal.");
      }
      if (response.status === 200 && response.data.status === 200) {
        console.log("API Response:", response.data);
      } else {
        toast.error(response.data.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error while submitting form. Please try again.");
    }
  };

  return (
    <PageLayout>
      <div className="mt-5 mb-5 container-fluid">
        <Card>
          <CardHeader className="bg-primary text-white text-center">
            <h3>{journalId ? "Update Journal" : "Create Journal"}</h3>
          </CardHeader>
          <CardBody>
            <JournalForm
              onSubmit={onSubmit}
              submitButton={
                <Button color="primary" type="submit" className="btn-block">
                  {journalId ? "Update / Save Changes" : "Add Journal"}
                </Button>
              }
            />
          </CardBody>
        </Card>
      </div>
    </PageLayout>
  );
};

export default CreateJournalPage;
